'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ArrowLeft, Home } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';

export default function NotFound() {
  const router = useRouter();

  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link
          href="/"
          className="inline-flex items-center gap-2.5 mb-12"
          aria-label="TypeSwift home"
        >
          <AppLogo size={26} />
          <span className="font-serif text-[1.0625rem] leading-none tracking-tight text-foreground">
            <span style={{ fontWeight: 600 }}>Type</span>
            <span style={{ fontWeight: 400, fontStyle: 'italic' }}>Swift</span>
          </span>
        </Link>

        <div
          className="py-10"
          style={{ borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}
        >
          <span className="eyebrow">Error 404</span>
          <h1
            className="font-serif text-foreground leading-none mt-4"
            style={{
              fontSize: 'clamp(4rem, 16vw, 6rem)',
              fontWeight: 600,
              letterSpacing: '-0.04em',
            }}
          >
            404
          </h1>
          <h2 className="font-serif text-xl text-foreground mt-6" style={{ fontWeight: 600 }}>
            Page not found
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed mt-2">
            The page you are looking for does not exist or has moved. Let us get you back to typing.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <button
            onClick={handleGoBack}
            className="btn-secondary inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm"
          >
            <ArrowLeft size={15} />
            Go back
          </button>
          <Link
            href="/"
            className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm"
          >
            <Home size={15} />
            Back to the typing test
          </Link>
        </div>
      </div>
    </div>
  );
}
